<template>
  <div class="">
    <dialog-v2
      :title="showName"
      :disable-save-btn="disableBtn"
      :class="{ [`${channel}-autocomplete-dialog`]: true }"
      :show="show"
      @save="tryToSave"
      @close="$emit('close')">
      <template slot="content">
        <sms-form
          v-if="channel === 'sms' || channel === 2"
          :form="form"
          :selected="selected.data"
          :autocomplete-list="autocompleteList"
          @updated="form[channel] = $event">
        </sms-form>
        <ivr-form
          v-if="channel === 'ivr' || channel === 3"
          :form="form"
          :selected="selected.data"
          :autocomplete-list="autocompleteList"
          @updated="form[channel] = $event">
        </ivr-form>
      </template>
    </dialog-v2>
    <delete-dialog
      :text="deleteOptions.text"
      :id="deleteOptions.id"
      url="templates"
      :dialog="deleteOptions.dialog"
      :delete-bus="deleteBus">
    </delete-dialog>
  </div>
</template>

<script>
import EventBus from '@/event-bus';
import DialogV2 from '@/components/global/DialogV2';
import DeleteDialog from '@/components/global/DeleteDialog';
import deleteDialogMixin from '@/mixins/deleteDialog';
import SmsForm from './SmsForm';
import IvrForm from './IvrForm';

export default {
  props: {
    channel: {
      type: String,
      default: 'sms',
    },
    type: {
      type: String,
      default: 'campaign',
    },
    selected: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [
    deleteDialogMixin,
  ],
  components: {
    IvrForm,
    SmsForm,
    DialogV2,
    DeleteDialog,
  },
  data() {
    return {
      route: 'templates',
      templateCode: '',
      templates: [],
      form: {
        channel: this.channel,
        name: '',
        template_code: '',
        category: '',
        text: '',
        sms: '',
        ivr: '',
        type: this.type,
      },
      fields: 'name,template_code,category,sms,ivr,voice',
      voices: [
        {
          value: 'hombre',
          text: 'Hombre',
        },
        {
          value: 'mujer',
          text: 'Mujer',
        },
      ],
      dialogBus: {
        created: 'createdTemplate',
        updated: 'updatedTemplate',
        modalOpened: 'modalOpenedTemplate',
        showMore: 'showMoreTemplate',
        editItem: 'editItemTemplate',
        closeModal: 'closeModalTemplate',
        openRightDrawer: 'openRightDrawerTemplate',
      },
      deleteBus: {
        onDelete: 'deleteItemTemplate',
        deleted: 'deletedTemplate',
        canceled: 'canceledTemplate',
      },
      text: '',
      backdropRef: `backdrop${this.channel}`,
      highlightsRef: `highlights${this.channel}`,
      autoCompleteListId: 'list',
      autocompleteList: [
        'nombre_completo',
        'nombre',
        'apellido',
        'monto',
        'fecha_vencimiento',
        'moneda',
        'mañana',
      ],
      counter: 0,
    };
  },
  created() {
    EventBus.$on('createTemplate', () => {
      this.dialog = true;
    });
    EventBus.$on(this.dialogBus.closeModal, () => {
      this.addCategory = true;
    });
    EventBus.$on(this.dialogBus.editItem, (id, templateCode) => {
      this.templateCode = templateCode;
    });
    EventBus.$on(this.dialogBus.updated, () => {
      this.dialog = false;
    });
    if (this.channel === 'sms') {
      this.autocompleteList.push('url');
    }
  },
  computed: {
    showName() {
      return `plantilla ${this.channel}`;
    },
    hasSpecialChar() {
      return /[^\w\s,.*$%/-@_]+/g.test(this.form.sms);
    },
    totalCharacter() {
      const tmp = document.createElement('div');
      tmp.innerHTML = this.form.sms;
      return (tmp.textContent || tmp.innerText).length || 0;
    },
    disableBtn() {
      if (this.channel === 'sms' && (this.hasSpecialChar || this.totalCharacter > 160)) {
        return true;
      }
      return false;
    },
  },
  methods: {
    tryToSave() {
      this.$emit('save', this.form);
    },
  },
  watch: {
    selected: {
      deep: true,
      handler(value) {
        this.form.id = value.id;
        this.form.channel = value.channel;
        this.form.templateCode = value.templateCode;
      },
    },
    'form.text': (newVal) => {
      this.form[this.channel] = newVal;
    },
    'form.sms'(newVal, oldVal) { // eslint-disable-line
      if (this.channel === 'sms' && newVal !== null) {
        const newText = newVal.split(' ');
        let trueValues = 0;
        this.autocompleteList.forEach((word) => {
          const findVal = newText.includes(`@${word}`);
          findVal ? trueValues++ : ''; // eslint-disable-line
        });
        this.maxLengthText = 160 - (10 * trueValues);
        if (!oldVal || !newVal) {
          this.text = newVal;
        }
      }
    },
    'form.ivr'(newVal, oldVal) { // eslint-disable-line
      if (this.channel === 'ivr' && newVal !== null) {
        const newText = newVal.split(' ');
        let trueValues = 0;
        this.autocompleteList.forEach((word) => {
          const findVal = newText.includes(`@${word}`);
          findVal ? trueValues++ : ''; // eslint-disable-line
        });
        this.maxLengthText = 160 - (10 * trueValues);
        if (!oldVal || !newVal) {
          this.text = newVal;
        }
      }
    },
    edit(newVal) {
      if (newVal && this.channel === 'ivr') {
        this.form.voice = '';
      }
    },
  },
};
</script>

<style scoped>
  .activeClass {
    color: red;
  }
  .sms-autocomplete-dialog >>> .card {
    height: 400px;
  }
</style>


// WEBPACK FOOTER //
// src/components/templateV2/FormModal.vue